// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"447":"webcam-segmentation","678":"PointCloudSharedArrayWorker"}[chunkId] || chunkId) + ".bundle.js";
};